export type Facing = 'down' | 'left' | 'right' | 'up';
export type WeatherState = 'sultry' | 'wind' | 'drizzle' | 'rain' | 'interior-rain';

export interface Settings {
  musicVolume: number;   // 0..1
  ambienceVolume: number;
  sfxVolume: number;
  muted: boolean;
  textSpeed: 'slow' | 'normal' | 'fast' | 'instant';
  reduceMotion: boolean;
  zoom: 'auto' | 1 | 2 | 3;
  fullscreen: boolean;
}

export const DEFAULT_SETTINGS: Settings = {
  musicVolume: 0.8,
  ambienceVolume: 0.8,
  sfxVolume: 0.9,
  muted: false,
  textSpeed: 'normal',
  reduceMotion: false,
  zoom: 'auto',
  fullscreen: false,
};

export interface Position { map: string; x: number; y: number; facing: Facing }

export interface SceneEntryData {
  spawn?: string;
  resumeFlag?: string;
  fromSave?: boolean;
  position?: Position | null;
}
